module.exports = __webpack_public_path__ + "static/img/Casebang_logo.1e81511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Casebang_logo.png
// module id = JdqF
// module chunks = 0